import React from "react";
import { clsx } from "clsx";
import form from "../data/form";
import SNS from "./SNS";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

interface IFooterProps extends React.PropsWithChildren {}

export default function Footer(props: IFooterProps) {
  return (
    <footer
      className={clsx(
        "bg-primary",
        "footer",
        "footer-center",
        "p-10",
        "text-primary-content",
      )}
    >
      <div>
        <span className="footer-title">サイトについて</span>
        <Link className="link link-hover" to="/tos">
          利用規約
        </Link>
        <Link className="link link-hover" to="/privacy-policy">
          プライバシーポリシー
        </Link>
        <a className="link link-hover" href={form.url}>
          お問い合わせ
        </a>
        <Link className="link link-hover" to="/license">
          ライセンス
        </Link>
      </div>
      <div>
        <span className="footer-title">SNS</span>
        <SNS />
      </div>
      <div>
        <StaticImage
          alt="Logo"
          className={clsx("w-10")}
          placeholder="blurred"
          src="../images/logo-white.png"
        />
        <Link className={clsx("font-icon", "text-center", "text-3xl")} to="/">
          ウィーンペディア
        </Link>
        <div className={clsx("text-sm")}>
          &copy; Wienpedia. All rights reserved
        </div>
      </div>
    </footer>
  );
}
